import * as React from "react";
import { styled } from "styled-components";

import { RadioButton } from "affinityUI/form/inputs/radioButton";

import { useAffinityField } from "../../../helpers";

const OptionContainer = styled.div<{ $error?: boolean }>`
  border: 1px solid ${(props) => (!props.$error ? props.theme.colours.bordersLight : props.theme.colours.error)};
  background: ${({ theme }) => theme.colours.white};
  border-radius: 6px;
  padding: 1rem;
`;

export const Option: React.FC<
  React.PropsWithChildren<{
    value?: string | number;
    name: string;
    label: string;
  }>
> = ({ value, name, label, children }) => {
  const [fieldData, { error }] = useAffinityField({ name, type: "radio", value });
  return (
    <OptionContainer $error={Boolean(error)}>
      <RadioButton error={Boolean(error)} id={`${name}_${value}`} {...fieldData} label={label}>
        {children}
      </RadioButton>
    </OptionContainer>
  );
};

Option.displayName = "Option";
